import React, { Suspense } from "react";
import { SecureRoute } from "@okta/okta-react";

import routes from "@/v1/config/routes";
import { useUserStore } from "@/v2/store/useUserStore";

const Router = () => {
  const isAdmin = useUserStore((state) => state.isAdmin);
  const userPermissions = useUserStore((state) => state.user?.permissions);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {routes
        .filter((route) => {
          const hasPermission = route.permissions
            ? userPermissions?.includes(route.permissions)
            : true;
          const isAdminOrNotRestricted = !route.adminRestricted || isAdmin;
          return hasPermission && isAdminOrNotRestricted;
        })
        .map((route) => (
          <SecureRoute key={route.path} {...route} />
        ))}
    </Suspense>
  );
};

export default Router;
